import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent implements OnInit {

  constructor() { }

  @Input() value;
  @Input() checked;
  @Output() switchChange = new EventEmitter();


  ngOnInit() {
  }

  changeSwitch(evt) {
    
    this.switchChange.emit(evt);
  }



}
